(function () {
  const STORAGE_KEY = 'mj_wishlist_v1';
  const EVENT_CHANGE = 'wishlist:change';

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter((h) => typeof h === 'string' && h.length > 0) : [];
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  function emit() {
    document.dispatchEvent(new CustomEvent(EVENT_CHANGE, { detail: { handles: read() } }));
  }

  const WishlistStore = {
    key: STORAGE_KEY,
    all() { return read(); },
    has(handle) { return read().indexOf(handle) !== -1; },
    add(handle) {
      if (!handle) return false;
      const list = read();
      if (list.indexOf(handle) !== -1) return false;
      list.push(handle);
      write(list);
      emit();
      return true;
    },
    remove(handle) {
      if (!handle) return false;
      const list = read();
      const idx = list.indexOf(handle);
      if (idx === -1) return false;
      list.splice(idx, 1);
      write(list);
      emit();
      return true;
    },
    toggle(handle) {
      return this.has(handle) ? (this.remove(handle), false) : (this.add(handle), true);
    },
    clear() { write([]); emit(); },
    count() { return read().length }
  };

  window.WishlistStore = WishlistStore;

  function refreshHeart(btn) {
    const handle = btn.dataset.wishlistHandle;
    if (!handle) return;
    const active = WishlistStore.has(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      active ? (btn.dataset.wishlistLabelRemove || 'Remove from wishlist')
             : (btn.dataset.wishlistLabelAdd || 'Add to wishlist')
    );
  }

  function refreshAllHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(refreshHeart);
  }

  function refreshCounts() {
    const count = WishlistStore.count();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function isLoggedIn() {
    return !!(window.mjCustomer && window.mjCustomer.logged_in && window.mjCustomer.email);
  }

  function getKlaviyo() {
    if (window.klaviyo && typeof window.klaviyo.push === 'function') return window.klaviyo;
    if (window._learnq && typeof window._learnq.push === 'function') return window._learnq;
    return null;
  }

  function syncKlaviyoProfile() {
    if (!isLoggedIn()) return;
    const kl = getKlaviyo();
    if (!kl) return;
    const handles = WishlistStore.all();
    const props = {
      '$email': window.mjCustomer.email,
      'wishlist_handles': handles,
      'wishlist_count': handles.length,
      'wishlist_updated_at': new Date().toISOString()
    };
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(props);
      } else {
        kl.push(['identify', props]);
      }
    } catch (e) {}
  }

  function trackWishlistEvent(eventName, extra) {
    const kl = getKlaviyo();
    if (!kl) return;
    const props = Object.assign({}, extra || {});
    if (isLoggedIn()) props['$email'] = window.mjCustomer.email;
    try {
      kl.push(['track', eventName, props]);
    } catch (e) {}
  }

  function productDataFromButton(btn) {
    return {
      product_handle: btn.dataset.wishlistHandle || '',
      product_title: btn.dataset.wishlistProductTitle || '',
      product_url: btn.dataset.wishlistProductUrl || (btn.dataset.wishlistHandle ? '/products/' + btn.dataset.wishlistHandle : ''),
      product_image: btn.dataset.wishlistProductImage || '',
      product_price: btn.dataset.wishlistProductPrice || '',
      product_id: btn.dataset.wishlistProductId || '',
      variant_id: btn.dataset.wishlistVariant || ''
    };
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.wishlistHandle;
    if (!handle) return;
    const willBeAdded = !WishlistStore.has(handle);
    WishlistStore.toggle(handle);
    const eventName = willBeAdded ? 'Added to Wishlist' : 'Removed from Wishlist';
    trackWishlistEvent(eventName, productDataFromButton(btn));
  });

  document.addEventListener(EVENT_CHANGE, function () {
    refreshAllHearts();
    refreshCounts();
    syncKlaviyoProfile();
  });

  function whenKlaviyoReady(cb) {
    if (getKlaviyo()) return cb();
    let tries = 0;
    const iv = setInterval(() => {
      tries++;
      if (getKlaviyo()) { clearInterval(iv); cb(); }
      else if (tries > 200) { clearInterval(iv); }
    }, 100);
  }

  ready(function () {
    if (isLoggedIn()) whenKlaviyoReady(syncKlaviyoProfile);
  });

  function ready(cb) {
    if (document.readyState !== 'loading') cb();
    else document.addEventListener('DOMContentLoaded', cb);
  }

  ready(function () {
    refreshAllHearts();
    refreshCounts();
  });

  if (window.MutationObserver) {
    const mo = new MutationObserver((records) => {
      let dirty = false;
      for (const r of records) {
        for (const node of r.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-wishlist-toggle]')) { dirty = true; break; }
          if (node.querySelector && node.querySelector('[data-wishlist-toggle]')) { dirty = true; break; }
        }
        if (dirty) break;
      }
      if (dirty) refreshAllHearts();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('storage', function (e) {
    if (e.key !== STORAGE_KEY) return;
    emit();
  });
})();
